/** @format */
import { createAction } from "redux-starter-kit";
export const restApiResponse = createAction("REST_API_RESPONSE");
